// Action creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
// Loaders
import { BaseActionCreatorLoader } from "../../base/loaders/BaseActionCreatorLoader";
/**
 * Loader class for loading action creators in the Web app
 */
export class WebActionCreatorLoader extends BaseActionCreatorLoader {
    constructor() {
        super(...arguments);
        this.loadSuiteNavViewActionCreator = () => this.loader.load(this.getActionCreatorBundleKey(ActionCreator.SuiteNavView), () => import(
        /* webpackChunkName: "planner-suitenavviewac" */ "@ms/planner-actioncreators/lib/local/actioncreators/view/SuiteNavViewActionCreator"), (bundle) => new bundle.SuiteNavViewActionCreator(this.logicModuleLoader, this.loggers));
    }
}
